import React, { useState } from 'react';
import SignIn from './SignIn';
import SignUp from './SignUp';

const Auth = () => {
  const [activeTab, setActiveTab] = useState('signin'); // 'signin' or 'signup'

  // Listen for switch to signup event
  React.useEffect(() => {
    const handleSwitchToSignUp = () => {
      setActiveTab('signup');
    };
    window.addEventListener('switchToSignUp', handleSwitchToSignUp);
    return () => window.removeEventListener('switchToSignUp', handleSwitchToSignUp);
  }, []);

  return (
    <div className="m-0 p-5 box-border font-sans bg-background-light flex justify-center items-center min-h-screen">
      <div className="login-container bg-white p-12 rounded-2xl shadow-md w-full max-w-[540px]">
        {/* Logo */}
        <div className="flex justify-center items-center mb-8">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_29_146)">
              <path d="M24 27.6C22.0125 27.6 20.4 25.9875 20.4 24C20.4 22.0125 22.0125 20.4 24 20.4C25.9875 20.4 27.6 22.0125 27.6 24C27.6 25.9875 25.9875 27.6 24 27.6Z" fill="#5432FF"/>
              <path d="M24 15.3C19.2 15.3 15.3 19.2 15.3 24C15.3 28.8 19.2 32.7 24 32.7C26.8805 32.7 29.5805 31.261 31.1388 28.861L27.7778 26.9414C26.8778 28.0805 25.4974 28.8024 23.9388 28.8024C21.2998 28.8024 19.1388 26.6414 19.1388 24.0024C19.1388 21.3634 21.2998 19.2024 23.9388 19.2024C25.4998 19.2024 26.8778 19.9219 27.7778 21.0633L31.1997 19.1392C29.5802 16.8001 26.8805 15.3 24 15.3Z" fill="#5432FF"/>
              <path d="M24 10.2C16.3806 10.2 10.2 16.3806 10.2 24C10.2 31.6194 16.3806 37.8 24 37.8C28.6805 37.8 33.0612 35.4 35.5806 31.4388L32.2196 29.5193C30.4196 32.2802 27.3001 33.9583 24.0002 33.9583C18.5393 33.9583 14.1002 29.5193 14.1002 24.0583C14.1002 18.5997 18.5393 14.0995 24.0002 14.0995C27.3002 14.0995 30.4196 15.78 32.2196 18.5386L35.5806 16.619C33.0611 12.6604 28.6806 10.2 24 10.2Z" fill="#5432FF"/>
              <path d="M24 5.10001C13.5612 5.10001 5.10001 13.5612 5.10001 24C5.10001 34.4388 13.5612 42.9 24 42.9C30.5388 42.9 36.6 39.4805 40.0194 33.9612L36.6584 32.0417C33.8998 36.3612 29.0996 39.0005 23.9996 39.0005C15.719 39.0005 8.99965 32.2811 8.99965 24.0005C8.99965 15.7199 15.719 9.00049 23.9996 9.00049C29.0996 9.00049 33.8996 11.6395 36.6608 15.9617L40.0218 14.0422C36.5999 8.52031 30.5388 5.10097 24 5.10097L24 5.10001Z" fill="#5432FF"/>
              <path d="M44.4612 36.5388L41.1002 34.6193C37.4393 40.4997 30.9614 44.1581 24.0002 44.1581C12.9002 44.1581 3.83904 35.1581 3.83904 24.0581C3.83904 12.9605 12.9002 3.89927 24.0002 3.89927C30.9614 3.89927 37.439 7.56023 41.1002 13.4381L44.4612 11.5185C40.2612 4.61855 32.6394 -0.000852911 24 -0.000853288C10.7388 -0.000853868 6.54807e-07 10.7379 7.51417e-08 23.9991C-5.04524e-07 37.2603 10.7388 47.9991 24 47.9991C32.6388 47.9991 40.2612 43.3796 44.4612 36.5379L44.4612 36.5388Z" fill="#5432FF"/>
            </g>
            <defs>
              <clipPath id="clip0_29_146">
                <rect width="48" height="48" fill="white" transform="translate(48 2.09815e-06) rotate(90)"/>
              </clipPath>
            </defs>
          </svg>
        </div>

        {/* Welcome Message */}
        <h1 className="login-title text-4xl font-semibold text-center text-gray-900 mb-3 font-sans">
          Welcome back
        </h1>
        <p className="login-subtitle text-center text-gray-500 text-base mb-8 leading-normal font-sans">
          Glad to see you again<br />Login to your account below
        </p>

        {/* Tab Switcher */}
        <div className="flex mb-6 border-b border-gray-200">
          <button
            onClick={() => setActiveTab('signin')}
            className={`flex-1 py-3 px-5 bg-transparent border-none border-b-2 font-sans text-base font-semibold cursor-pointer transition-all duration-200 -mb-0.5 ${
              activeTab === 'signin'
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-gray-500'
            }`}
          >
            Sign In
          </button>
          <button
            onClick={() => setActiveTab('signup')}
            className={`flex-1 py-3 px-5 bg-transparent border-none border-b-2 font-sans text-base font-semibold cursor-pointer transition-all duration-200 -mb-0.5 ${
              activeTab === 'signup'
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-gray-500'
            }`}
          >
            Sign Up
          </button>
        </div>

        {/* Form */}
        <div className="w-full">
          {activeTab === 'signin' ? (
            <SignIn />
          ) : (
            <SignUp onSwitchToSignIn={() => setActiveTab('signin')} />
          )}
        </div>
      </div>

    </div>
  );
};

export default Auth;
